import { render, staticRenderFns } from "./PcPcmTapFlcTable.vue?vue&type=template&id=842f6e16&"
import script from "./PcPcmTapFlcTable.vue?vue&type=script&lang=js&"
export * from "./PcPcmTapFlcTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports